//@ts-check
import { exceptPriceItems } from '@/office/setting-office/setting-report/report-item';
import AES from 'crypto-js/aes';
import Base64 from 'crypto-js/enc-base64';
import hex from 'crypto-js/enc-hex';
import Utf8 from 'crypto-js/enc-utf8';
import MD5 from 'crypto-js/md5';
import ECB from 'crypto-js/mode-ecb';
import Pkcs7 from 'crypto-js/pad-pkcs7';
import moji from 'moji';
import * as wanakana from 'wanakana';

/** 英数字とスペースだけ */
export const hanToZen = (str) =>
  moji(str).convert('HE', 'ZE').convert('HS', 'ZS').toString();

/** 英数字とスペースだけ */
export const zenToHan = (str) =>
  moji(str).convert('ZE', 'HE').convert('ZS', 'HS').toString();

/** 全部（英数字・スペース・カタカナ） */
export const hanToZenAll = (str) =>
  moji(str).convert('HE', 'ZE').convert('HS', 'ZS').convert('HK', 'ZK').toString();

/** 全部（英数字・スペース・カタカナ） */
export const zenToHanAll = (str) =>
  moji(str).convert('ZE', 'HE').convert('ZS', 'HS').convert('ZK', 'HK').toString();

export const ganaToKana = (str) =>
  moji(str).convert('HG', 'KK').toString();

export const kanaToGana = (str) =>
  moji(str).convert('KK', 'HG').toString();

export const spaceZenToHan = (str) =>
  moji(str).convert('ZS', 'HS').toString();

export const kanaToRomaji = (str) =>
  wanakana.toRomaji(str);


export const matchPhoneStart = (phone) => {
  if (phone == null) {
    return false;
  }
  return !!phone.match(/^050|^060|^070|^080|^090/);
};

export const removePhoneHyphen = (_phone) => {
  if (_phone == null) {
    return _phone;
  }

  const phone = zenToHan(_phone).trim();
  return phone.replace(/ー|ｰ|－|―|‐|-|\+/g, '');
};

export const formatPhone = (_phone) => {
  if (_phone == null) {
    return _phone;
  }

  const phone = _phone.trim();
  if (phone.indexOf('-') !== -1) {
    return phone;
  }

  if (phone.length == 11 && phone.indexOf('0800') === 0) {
    return `${phone.substring(0, 4)}-${phone.substring(4, 7)}-${phone.substring(7, 11)}`;
  }

  if (phone.length == 11) {
    return `${phone.substring(0, 3)}-${phone.substring(3, 7)}-${phone.substring(7, 11)}`;
  }

  if (phone.length == 10 && (phone.indexOf('03') === 0 || phone.indexOf('06') === 0)) {
    return `${phone.substring(0, 2)}-${phone.substring(2, 6)}-${phone.substring(6, 10)}`;
  }

  if (phone.length == 10 && (phone.indexOf('0120') === 0 || phone.indexOf('0800') === 0)) {
    return `${phone.substring(0, 4)}-${phone.substring(4, 6)}-${phone.substring(6, 10)}`;
  }

  if (phone.length == 10) {
    return `${phone.substring(0, 3)}-${phone.substring(3, 6)}-${phone.substring(6, 10)}`;
  }

  return phone;
};

export const isPhone = (phone) => {
  if (!phone) {
    return false;
  }
  if (['P', 'O', 'C', 'U'].includes(phone)) {
    return false;
  }
  return matchPhoneStart(phone);
};

export const phoneView = (phone) => {
  switch (phone) {
    case 'P':
      return '非通知';
    case 'O':
      return '範囲外';
    case 'C':
      return '公衆電話';
    case 'U':
      return '不明';
  }
  return formatPhone(phone);
};

export const numToAlpha = (str) => {
  const xx = '01234567';
  const yy = 'ABCDEFGH';
  str += '';
  for (let i = 0; i < xx.length; i++) {
    const re = new RegExp(xx[i], 'g');
    str = str.replace(re, yy[i]);
  }
  return str;
};

const PRICE_EX = [4, 8, 12].reverse();
const PRICE_EX_NAME = ['万', '億', '兆'].reverse();
const toJPUnit = (price) => {
  if (price == null) {
    return;
  }
  const minus = price < 0;
  price = minus ? price * -1 : price;
  let sb = '';
  PRICE_EX.forEach((ex, i) => {
    const bias = 10 ** ex;
    if (price >= bias) {
      const top = Math.floor(price / bias);
      price %= bias;
      sb += top;
      sb += PRICE_EX_NAME[i];
    }
  });
  if (price != 0) {
    sb += price;
  }
  return (minus ? '-' + sb : sb) || 0;
};

export const jpToNum = (jp) => {
  if (jp == null) {
    return;
  }
  const minus = jp.includes('-');
  jp = jp.replace('円', '');
  jp = jp.replace('-', '');
  let price = 0;
  PRICE_EX.forEach((ex, i) => {
    const bias = 10 ** ex;
    if (jp.includes(PRICE_EX_NAME[i])) {
      const num = Number(jp.substr(0, jp.indexOf(PRICE_EX_NAME[i])));
      price += num * bias;
    }
  });
  if (jp.includes('万')) {
    price += Number(jp.substr(jp.indexOf('万') + 1));
  } else {
    price += Number(jp);
  }
  return minus ? price * -1 : price;
};

export const createViewPrice = (type, price) => {
  if (price == undefined) {
    return '';
  }
  if (price == '-') {
    return price;
  }
  if (isNaN(price)) {
    return '';
  }
  let isMinus = false;
  if (price < 0) {
    isMinus = true;
    price = price * (-1);
  }
  switch (Number(type)) {
    case 0:
      return isMinus ? '-' + price : price;
    case 1:
      return isMinus ? '-' + price + '円' : price + '円';
    case 2:
      return isMinus ? '-' + price.toLocaleString() : price.toLocaleString();
    case 3:
      return isMinus ? '-' + price.toLocaleString() + '円' : price.toLocaleString() + '円';
    case 4:
      return isMinus ? '-' + toJPUnit(price) + '円' : toJPUnit(price) + '円';
    default:
      return price;
  }
};

export const getDisplayData = (viewPrice, label, cellData, extList = []) => {
  const ext = extList.find(ex => ex[0] === label);
  if (ext) {
    return ext[2] ? createViewPrice(viewPrice, cellData) : cellData;
  }
  if (0 <= label.indexOf('(本数)')) {
    return cellData;
  }
  if (label === '出勤時間') {
    formatHour(cellData);
  }
  if (label == '着信人数(媒体)' || label == '着信人数(スタッフ)') {
    return cellData;
  }
  return exceptPriceItems.includes(label) ? cellData : createViewPrice(viewPrice, cellData);
};

function formatHour(x) {
  if (x === 0) {
    return 0;
  }
  return Number.parseFloat(x).toFixed(1) + 'h';
}

const secretKey = Base64.parse(btoa('Q893S4eEcpFGGeUf'));
export const blnDecrypt = (str) => {
  const decrypted = AES.decrypt(
    str,
    secretKey,
    {
      mode: ECB,
      padding: Pkcs7
    }
  );
  return JSON.parse(decrypted.toString(Utf8));
};

export const md5Hash = (file) => {
  const hash = MD5(file);
  return hash.toString(hex);
};

export const mailCheck = (address) => {
  const reg = /.+@.+/;
  return reg.test(address);
};

export const kanaCheck = (str) => {
  if (!isZenkakuKana(str)) {
    return isHankakuKana(str);
  }
  return true;
};

// 全角カナ、全角数字、半角数字、半角スペース、を許可
const isZenkakuKana = (s) => {
  return !!s.match(/^[Ａ-Ｚａ-ｚァ-ヶ０-９0-9ー\s]*$/);
};

// 半角カナ、半角スペース、半角数字、を許可
const isHankakuKana = (s) => {
  return !!s.match(/^[ｦ-ﾟ 0-9]*$/);
};

export const textEllipsis = (text, maxLen) => {
  if (text.length - maxLen <= 2) {
    return text;
  }
  return text.slice(0, maxLen) + '...';
};

//zenToHanでカバーできない場合に使用
export const zenkana2Hankana = (str) => {
  const kanaMap = {
    'ガ': 'ｶﾞ', 'ギ': 'ｷﾞ', 'グ': 'ｸﾞ', 'ゲ': 'ｹﾞ', 'ゴ': 'ｺﾞ',
    'ザ': 'ｻﾞ', 'ジ': 'ｼﾞ', 'ズ': 'ｽﾞ', 'ゼ': 'ｾﾞ', 'ゾ': 'ｿﾞ',
    'ダ': 'ﾀﾞ', 'ヂ': 'ﾁﾞ', 'ヅ': 'ﾂﾞ', 'デ': 'ﾃﾞ', 'ド': 'ﾄﾞ',
    'バ': 'ﾊﾞ', 'ビ': 'ﾋﾞ', 'ブ': 'ﾌﾞ', 'ベ': 'ﾍﾞ', 'ボ': 'ﾎﾞ',
    'パ': 'ﾊﾟ', 'ピ': 'ﾋﾟ', 'プ': 'ﾌﾟ', 'ペ': 'ﾍﾟ', 'ポ': 'ﾎﾟ',
    'ヴ': 'ｳﾞ', 'ヷ': 'ﾜﾞ', 'ヺ': 'ｦﾞ',
    'ア': 'ｱ', 'イ': 'ｲ', 'ウ': 'ｳ', 'エ': 'ｴ', 'オ': 'ｵ',
    'カ': 'ｶ', 'キ': 'ｷ', 'ク': 'ｸ', 'ケ': 'ｹ', 'コ': 'ｺ',
    'サ': 'ｻ', 'シ': 'ｼ', 'ス': 'ｽ', 'セ': 'ｾ', 'ソ': 'ｿ',
    'タ': 'ﾀ', 'チ': 'ﾁ', 'ツ': 'ﾂ', 'テ': 'ﾃ', 'ト': 'ﾄ',
    'ナ': 'ﾅ', 'ニ': 'ﾆ', 'ヌ': 'ﾇ', 'ネ': 'ﾈ', 'ノ': 'ﾉ',
    'ハ': 'ﾊ', 'ヒ': 'ﾋ', 'フ': 'ﾌ', 'ヘ': 'ﾍ', 'ホ': 'ﾎ',
    'マ': 'ﾏ', 'ミ': 'ﾐ', 'ム': 'ﾑ', 'メ': 'ﾒ', 'モ': 'ﾓ',
    'ヤ': 'ﾔ', 'ユ': 'ﾕ', 'ヨ': 'ﾖ',
    'ラ': 'ﾗ', 'リ': 'ﾘ', 'ル': 'ﾙ', 'レ': 'ﾚ', 'ロ': 'ﾛ',
    'ワ': 'ﾜ', 'ヲ': 'ｦ', 'ン': 'ﾝ',
    'ァ': 'ｧ', 'ィ': 'ｨ', 'ゥ': 'ｩ', 'ェ': 'ｪ', 'ォ': 'ｫ',
    'ッ': 'ｯ', 'ャ': 'ｬ', 'ュ': 'ｭ', 'ョ': 'ｮ',
    '。': '｡', '、': '､', 'ー': 'ｰ', '「': '｢', '」': '｣', '・': '･'
  };
  let reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
  return str
    .replace(reg, function (match) {
      return kanaMap[match];
    })
    .replace(/゛/g, 'ﾞ')
    .replace(/゜/g, 'ﾟ');
};

// name flavor operations

/**
 * Converts a string in snake_case to camelCase.
 * @param {string} str - The snake_case string.
 * @returns {string} The camelCase string.
 */
export const snakeToCamel = (str) => {
  return str.replace(/(_\w)/g, match => match[1].toUpperCase());
};

/**
 * Converts a string in camelCase to PascalCase.
 * @param {string} str - The camelCase string.
 * @returns {string} The PascalCase string.
 */
export const camelToPascal = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Converts a string in PascalCase to snake_case.
 * @param {string} str - The PascalCase string.
 * @returns {string} The snake_case string.
 */
export const pascalToSnake = (str) => {
  const ret = str.replace(/[A-Z]/g, match => '_' + match.toLowerCase());
  return ret.charAt(0) === '_' ? ret.slice(1) : ret;
};

/**
 * Checks if a string is in snake_case.
 * @param {string} str - The string to check.
 * @returns {boolean} Indicates if the string is in snake_case.
 */
export const isSnakeCase = (str) => {
  return /^[a-z]+(?:_[a-z0-9]+)*$/.test(str);
};

/**
 * Checks if a string is in camelCase.
 * @param {string} str - The string to check.
 * @returns {boolean} Indicates if the string is in camelCase.
 */
export const isCamelCase = (str) => {
  return /^[a-z]+(?:[A-Z][a-z0-9]*)*$/.test(str);
};

/**
 * Checks if a string is in PascalCase.
 * @param {string} str - The string to check.
 * @returns {boolean} Indicates if the string is in PascalCase.
 */
export const isPascalCase = (str) => {
  return /^(?:[A-Z][a-z0-9]*)+$/.test(str);
};

/**
 * 入力した数字からマイナスと小数点を消す
 * @param {string | number} num 
 */
export const toPositiveWholeNumber = (num) => {
  if (Number.isNaN(num)) return 0;
  num = num.toString().replace('-', '');
  num = Math.floor(Number(num));
  return num;
};